import React, { useEffect } from 'react'
import { NavBar } from 'components/NavBar/NavBar'
import { clearClientRole, getSingleClientRole } from 'features/roles/clientRolesSlice'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import {
  Button,
  Flex,
  H1WithBack,
  PageWrapper,
  Box,
  ThinSeparator,
  ItemsGrid,
} from 'styling/GlobalStyles'
import { AppDispatch, RootState } from 'store'
import { ISingleClientRoleGetResponse } from 'types/api/clientRoles.interface'
import { BodyText, OtherText, ParagraphText, TitleText } from 'styling/Typography'
import { days, shiftChangeTypes } from 'pages/Employees/employeesData'
import { ScheduleWeeklyCard } from 'pages/Shifts/Shifts.styled'
import { SunriseIcon } from 'pages/Shifts/Icons/SunriseIcon'
import { HeartIcon } from 'pages/Shifts/Icons/HeartIcon'
import { SunsetIcon } from 'pages/Shifts/Icons/SunsetIcon'
import { RotationIcon } from 'pages/Shifts/Icons/RotationIcon'
import { BeachIcon } from 'pages/Shifts/Icons/BeachIcon'
import { DrinkIcon } from 'pages/Shifts/Icons/DrinkIcon'
import { SunIcon } from 'pages/Shifts/Icons/SunIcon'
import { convertMinsToHrsMins } from 'utils/helpers'

export const SingleRole = () => {
  const navigate = useNavigate()
  const { singleRole } = useSelector((store: RootState) => store.clientRoles)
  const { id } = useParams()
  const dispatch = useDispatch<AppDispatch>()
  const roleData = singleRole as unknown as ISingleClientRoleGetResponse

  useEffect(() => {
    dispatch(getSingleClientRole(id))

    return () => {
      dispatch(clearClientRole())
    }
  }, [dispatch, id])

  const getIcon = (icon: string, color: string) => {
    switch (icon) {
      case 'sunrise':
        return <SunriseIcon stroke={color || '#ff9900'} />
      case 'sunset':
        return <SunsetIcon stroke={color || '#ff9900'} />
      case 'rotation':
        return <RotationIcon stroke={color || '#ff9900'} />
      case 'beach':
        return <BeachIcon stroke={color || '#ff9900'} />
      case 'drink':
        return <DrinkIcon stroke={color || '#ff9900'} />
      case 'sun':
        return <SunIcon stroke={color || '#ff9900'} />
      case 'heart':
        return <HeartIcon stroke={color || '#ff9900'} />
      default:
        return null
    }
  }

  console.log(roleData)

  return (
    <>
      <NavBar />
      <PageWrapper>
        <Flex between>
          <H1WithBack title={roleData?.name || 'Role Details'} arrow />
          <Button orange onClick={() => navigate('edit')}>
            Edit Role
          </Button>
        </Flex>
        {/* <TitleText weight='bold' style={{ fontSize: 24, lineHeight: '32px', marginTop: 32 }} >Work Schedule</TitleText> */}

        <Flex mt='16' width='100%' gap='2rem'  >
          <Box width='100%' >
            <TitleText weight='bold' style={{ fontSize: 18 }} >Work Schedule Model</TitleText>
            <Flex width='100%' >
              <Flex width='100%' column>
                <OtherText grey style={{ marginTop: '1rem' }}>SCHEDULE MODEL</OtherText>
                <BodyText style={{ marginTop: '0.2rem' }} >{roleData?.workScheduleModel?.name || '-'}</BodyText>
              </Flex>
              <Flex width='100%' column>
                <OtherText grey style={{ marginTop: '1rem' }}>FREE DAYS</OtherText>
                <BodyText style={{ marginTop: '0.2rem' }} >{roleData?.freeDays.map(d => days[d - 1].label).join(', ')}</BodyText>
              </Flex>
            </Flex>
            <ThinSeparator />
            <OtherText grey style={{ marginTop: '1rem' }}>SCHEDULE MODEL</OtherText>
            <ItemsGrid columns={3} style={{ marginTop: '0.5rem' }} >
              {roleData?.shifts?.map(({ shift }) => <ScheduleWeeklyCard key={shift.id} style={{ width: '150px', height: 60 }} color={'#' + shift.color} >
                <Flex gap='0.5rem' center >
                  {getIcon(shift.icon, '#' + shift.iconColor)}
                  <Flex column >

                    <BodyText
                      style={{
                        whiteSpace: 'nowrap',
                        textOverflow: 'ellipsis',
                        overflow: 'hidden',
                        maxWidth: '100%',
                        color: '#' + shift.textColor
                      }}
                      weight='bold' >{shift.name || 'Shift name'}
                    </BodyText>
                    <ParagraphText style={{ color: '#' + shift.textColor }} >
                      {convertMinsToHrsMins(shift.minutes)}-{convertMinsToHrsMins(shift.minutes, shift.shiftStart)}
                    </ParagraphText>
                  </Flex>
                </Flex>
              </ScheduleWeeklyCard>)}
            </ItemsGrid>
          </Box>
          <Box width='100%' >
            <TitleText weight='bold' style={{ fontSize: 18 }} >Vacation days</TitleText>
            <Flex width='100%' center justcenter style={{ minHeight: '150px' }} >
              <TitleText weight='bold' style={{ fontSize: 32, marginTop: '1rem', color: '#ff9900' }} >{roleData?.vacationDays || '-'}</TitleText>
            </Flex>
          </Box>
          <Box width='100%' >
            <TitleText weight='bold' style={{ fontSize: 18 }} >Shift Configuration</TitleText>
            <Flex width='100%' column>
              <Flex width='100%' column>
                <OtherText grey style={{ marginTop: '1rem' }}>SHIFT CHANGE TYPE</OtherText>
                <BodyText style={{ marginTop: '0.2rem' }} >{shiftChangeTypes.find(s => s.value == roleData?.shiftChangeType)?.label || '-'}</BodyText>
              </Flex>
              <Flex width='100%' column>
                <OtherText grey style={{ marginTop: '1rem' }}>SHIFT CHANGE INTERVAL</OtherText>
                <BodyText style={{ marginTop: '0.2rem' }} >{roleData?.shiftChangeInterval || '-'}</BodyText>
              </Flex>
            </Flex>
          </Box>
        </Flex>
        {/* <TitleText weight='bold' style={{ fontSize: 24, lineHeight: '32px', marginTop: 32 }} >Permissions</TitleText> */}
        <Flex width='100%' gap='1rem' mt='16' >
          <Box width='100%'>
            <Flex column  >
              <TitleText weight='bold' style={{ fontSize: 18 }} >Permission Policy</TitleText>
              <OtherText grey style={{ marginTop: '1rem' }}>POLICY NAME</OtherText>
              <BodyText >{roleData?.permissionPolicy?.policyName || '-'}</BodyText>
              <OtherText grey style={{ marginTop: '1rem' }}>PERMISSIONS</OtherText>
              <Flex column gap='0.2rem' >{Object.keys(roleData?.permissions || {}).filter(p => roleData.permissions[p]).map(p => <BodyText key={p} >- {capitalizeFirstLetter(p)}</BodyText>)}</Flex>
            </Flex>
          </Box>

          <Box width='100%' >
            <Flex column gap='1rem' >
              <TitleText weight='bold' style={{ fontSize: 18 }} >Welfare</TitleText>
              <OtherText grey style={{ marginTop: '1rem' }}>HAS TRANSPORTATION ALLOWANCE</OtherText>
              <BodyText >{roleData?.logisticsInfo?.hasTransportationAllowance ? 'Yes' : 'No'}</BodyText>
              {roleData?.logisticsInfo?.hasTransportationAllowance && <>
                <OtherText grey style={{ marginTop: '1rem' }}>TRANSPORTATION ALLOWANCE IN COMPANY AMOUNT</OtherText>
                <BodyText >{roleData?.logisticsInfo?.transportationAllowanceInCompanyAmount}</BodyText>
                <OtherText grey style={{ marginTop: '1rem' }}>TRANSPORTATION ALLOWANCE OUT OF COMPANY AMOUNT</OtherText>
                <BodyText >{roleData?.logisticsInfo?.transportationAllowanceOutCompanyAmount}</BodyText>
              </>}
              <OtherText grey style={{ marginTop: '1rem' }}>HAS RESPONSIBILITY ALLOWANCE</OtherText>
              <BodyText >{roleData?.logisticsInfo?.hasResponsibilityAllowance ? 'Yes' : 'No'}</BodyText>
              {roleData?.logisticsInfo?.hasResponsibilityAllowance && <>
                <OtherText grey style={{ marginTop: '1rem' }}>RESPONSIBILITY ALLOWANCE IN COMPANY AMOUNT</OtherText>
                <BodyText >{roleData?.logisticsInfo?.responsibilityAllowanceInCompanyAmount}</BodyText>
                <OtherText grey style={{ marginTop: '1rem' }}>RESPONSIBILITY ALLOWANCE OUT OF COMPANY AMOUNT</OtherText>
                <BodyText >{roleData?.logisticsInfo?.responsibilityAllowanceOutCompanyAmount}</BodyText>
              </>}
              <OtherText grey style={{ marginTop: '1rem' }}>HAS EXTRA DUTY ALLOWANCE</OtherText>
              <BodyText >{roleData?.logisticsInfo?.hasExtraDutyAllowance ? 'Yes' : 'No'}</BodyText>
              {roleData?.logisticsInfo?.hasExtraDutyAllowance && <>
                <OtherText grey style={{ marginTop: '1rem' }}>EXTRA DUTY ALLOWANCE IN COMPANY AMOUNT</OtherText>
                <BodyText >{roleData?.logisticsInfo?.extraDutyAllowanceInCompanyAmount}</BodyText>
                <OtherText grey style={{ marginTop: '1rem' }}>EXTRA DUTY ALLOWANCE OUT OF COMPANY AMOUNT</OtherText>
                <BodyText >{roleData?.logisticsInfo?.extraDutyAllowanceOutCompanyAmount}</BodyText>
              </>}
            </Flex>
          </Box>
        </Flex>

      </PageWrapper>
    </>
  )
}

function capitalizeFirstLetter(string) {
  if (string.length === 0) {
    return '';
  }
  return string.charAt(0).toUpperCase() + string.slice(1);
}